// https://beareact.dev/gatsby-browser-console-errors-in-production/
import browserHydrateFunction from '#utils/browserHydrateFunction';

export const replaceHydrateFunction = browserHydrateFunction;